// src/features/test-plans/api/useBuilds.ts
// Standalone builds hooks — imported by BuildsPage, ExecutionsPage, RecordExecutionPage
// Re-exports query/create/update from useTestPlans; provides simplified delete (id-only)
// All endpoints verified against openapi.json (testplan-service)

import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '@/lib/api/client'
import { API_CONFIG } from '@/lib/config/api.config'

// Re-export everything from the combined file
export {
  buildKeys,
  useBuilds,
  useBuild,
  useCreateBuild,
  useUpdateBuild,
} from './useTestPlans'

// Import keys for cache invalidation
import { buildKeys } from './useTestPlans'

// ============================================================================
// Standalone Delete Build — simplified signature (id only)
// Pages like BuildsPage and ExecutionsPage don't always have testplanId context.
// DELETE /api/builds/{build_id} — Returns 204
// ============================================================================

export const useDeleteBuild = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (id: number) => {
      await apiClient.delete(API_CONFIG.ENDPOINTS.BUILDS.DELETE(id.toString()))
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: buildKeys.lists() })
    },
  })
}
